import React from "react";
import Page from "../components/Page";

// Imports
import { useSelector } from "react-redux";
import { usePullData } from "../hooks/usePullData";
import { renderCollection } from "../util/renderCollection";

// Import for Displays
import Accordion from "../components/Accordion";
import RichText from "../components/RichText";
import FAQs from "../components/FAQs";
import LoadingPage from "./LoadingPage";

function AboutPage() {
  // Accessing data.
  const singleTypeSlug = "about-us";
  const { data } = useSelector((state) => state.cms);
  const cmsData = data[singleTypeSlug] && data[singleTypeSlug].attributes;

  const staffSlug = "staff-members";
  const staffData = data[staffSlug];

  const faqSlug = "faqs";
  const faqData = data[faqSlug];

  // Only load if data has returned.
  if (!cmsData | staffData | faqData) return <LoadingPage />;

  return (
    <Page data-wf-page="63500187b74a6d39e7c4f30f" data-wf-site="634efd6b20b65bfc05be44e4">
      {/* About Us */}
      <div
        className="section wf-section"
        style={{
          height: "70vh",
          backgroundImage: `url(${cmsData.headerPhoto.data && cmsData.headerPhoto.data.attributes.url}`,
          backgroundPosition: "50% 100%",
          backgroundSize: "cover",
        }}
      ></div>
      <div className="section wf-section">
        <div className="container w-container">
          <h1>{cmsData.title}</h1>
          <RichText text={cmsData.richText} />
        </div>
      </div>

      {/* Logo */}
      <div className="section wf-section">
        <div className="containercentered w-container">
          <img src={cmsData.logoImage.data && cmsData.logoImage.data.attributes.url} loading="lazy" height="" width={165} alt="The Royal Canadian Air Cadets' logo." />
        </div>
      </div>

      {/* Staff Members */}
      <div className="section wf-section">
        <div className="container w-container">
          <h2>{cmsData.staffHeading}</h2>
          <div className="w-layout-grid gridstaff">{renderCollection(StaffEntry, staffData, staffSlug)}</div>
        </div>
      </div>

      {/* Fixed Image Section*/}
      <div
        className="section wf-section"
        style={{
          background: `linear-gradient(180deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${cmsData.fixedImage.data && cmsData.fixedImage.data.attributes.url})`,
          "background-position": `0px 0px, 0px 0px`,
          "background-size": `auto, cover`,
          "background-attachment": `scroll, fixed`,
        }}
      >
        <div className="container w-container">
          <div className="divfixedimage">
            <div>
              <h2 className="textwhite">{cmsData.heading2}</h2>
            </div>
            <p className="textwhite">{cmsData.richText2}</p>
          </div>
        </div>
      </div>

      {/* FAQ */}
      <div className="section wf-section">
        <Accordion></Accordion>
        <div className="container w-container">
          <h2>{cmsData.FAQHeading}</h2>
          <FAQs data={faqData} />
        </div>
      </div>

      {/* Location */}
      <div className="section wf-section">
        <div className="container containercentered w-container">
          <h2>{cmsData.locationHeading}</h2>
          <div className="calendar w-embed w-iframe">
            <iframe title="Map" src={cmsData.mapsURL} width="100%" height={450} style={{ border: 0 }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
          </div>
        </div>
      </div>
    </Page>
  );
}

export default AboutPage;

// Staff Members
const StaffEntry = (props) => {
  let data = usePullData(props);
 // console.log(data);

  return (
    <div id="w-node-_34e61fe9-816a-c304-65aa-56d5abfa978e-abfa978e" className="divstaff">
      <img src={data.headshot.data && data.headshot.data.attributes.url} loading="lazy" alt="" className="circleimage" />
      <h5 className="textwhite textcenter">
        <strong>{data.name}</strong>
      </h5>
      <h6 className="textwhite positiontext">{data.title}</h6>
    </div>
  );
};
